import TabBarContent from './tab-bar-content';
import { TabProvider } from './tab-context';
import { TabBarItem, TabSize, TabType } from './types';
interface Props {
  size: TabSize;
  type?: TabType;
  items: TabBarItem[];
  defaultIndex?: number;
  headClassName?: string;
  bodyClassName?: string;
  tabGroupClassName?: string;
  tabClassName?: string;
  isProductsHeader?: boolean;
  hasLeftPadding?: boolean;
}
const TabBar = ({
  size = TabSize.Medium,
  type = TabType.Normal,
  items,
  defaultIndex = 0,
  headClassName,
  bodyClassName,
  tabGroupClassName,
  tabClassName,
  isProductsHeader,
  hasLeftPadding
}: Props) => {
  return <TabProvider data-sentry-element="TabProvider" data-sentry-component="TabBar" data-sentry-source-file="tab-bar.tsx">
            <TabBarContent size={size} type={type} items={items} defaultIndex={defaultIndex} headClassName={headClassName} bodyClassName={bodyClassName} tabGroupClassName={tabGroupClassName} tabClassName={tabClassName} isProductsHeader={isProductsHeader} hasLeftPadding={hasLeftPadding} data-sentry-element="TabBarContent" data-sentry-source-file="tab-bar.tsx" />
        </TabProvider>;
};
export default TabBar;